<div class="w-full h-full flex flex-col items-center justify-start px-4 sm:px-6 flex-1 overflow-hidden pb-6">
    <h2
        class="text-2xl font-semibold tracking-tight text-balance text-primary sm:text-4xl md:text-5xl text-center sm:text-left use-grotesque">
        Which brands do you
        <span class="bg-gradient-to-r from-primary to-brand-studio bg-clip-text text-transparent">represent</span>?
    </h2>
    <p class="mx-auto mt-2 max-w-xl text-base sm:text-lg/8 text-pretty text-secondary text-center sm:text-left">
        Add every brand your agency manages. You can invite teams, attach contracts, and start campaigns once they're
        in. You can always add more later.</p>


    <div class="w-full max-w-4xl flex-1 flex flex-col mt-2 sm:mt-8 gap-y-2">
        <div class="flex-1 flex flex-col gap-y-4 overflow-y-auto scrollbar-transparent w-full p-2">
            <ul role="list" class="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">

                <!-- New brand card -->
                <div (click)="launchAddBrand()"
                    class="group col-span-1 relative block w-full rounded-lg border-2 border-dashed border-gray-300 p-12 text-center hover:border-gray-400 focus:outline-2 focus:outline-offset-2 focus:outline-primary dark:border-white/15 dark:hover:border-white/25 dark:focus:outline-primary hover:scale-105 transition-all duration-300 cursor-pointer">
                    <button type="button" class="mx-auto fab-button-primary">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                            class="size-5">
                            <path d="M5 12h14" />
                            <path d="M12 5v14" />
                        </svg>
                    </button>

                    @if (allBrands() && allBrands().length > 0) {
                    <h3 class="mt-4 text-sm font-semibold text-gray-900 dark:text-white">Add another brand</h3>
                    } @else {
                    <h3 class="mt-4 text-sm font-semibold text-gray-900 dark:text-white">Add a brand</h3>
                    }
                    <p class="mt-1 text-sm text-gray-500 dark:text-gray-400 inline-flex items-center gap-x-1">
                        Logo
                        <svg viewBox="0 0 6 6" aria-hidden="true" class="size-1 fill-gray-500 dark:fill-gray-400">
                            <circle r="3" cx="3" cy="3" />
                        </svg>
                        name
                        <svg viewBox="0 0 6 6" aria-hidden="true" class="size-1 fill-gray-500 dark:fill-gray-400">
                            <circle r="3" cx="3" cy="3" />
                        </svg>
                        website
                        <svg viewBox="0 0 6 6" aria-hidden="true" class="size-1 fill-gray-500 dark:fill-gray-400">
                            <circle r="3" cx="3" cy="3" />
                        </svg>
                        bio
                    </p>
                </div>
                <!-- New brand card - END -->

                @for (brand of allBrands(); track $index) {
                <div
                    class="group col-span-1 relative block w-full rounded-lg border-2 border-gray-300 p-12 text-center hover:border-gray-400 focus:outline-2 focus:outline-offset-2 focus:outline-primary dark:border-white/15 dark:hover:border-white/25 dark:focus:outline-primary hover:scale-105 transition-all duration-300 cursor-pointer">
                    <img class="mx-auto size-12 flex-none rounded-full bg-gray-50 dark:bg-zinc-800"
                        [src]="imageService.getImageSource(brand.companyLogo, 'gallery')" alt="">

                    <h3 class="mt-4 text-sm font-semibold text-gray-900 dark:text-white">{{ brand.companyName }}</h3>
                    <p class="mt-1 text-sm text-gray-500 dark:text-gray-400 inline-flex items-center gap-x-1">
                        {{ brand.website }}
                    </p>
                </div>
                }

            </ul>
        </div>
        <div class="shrink-0 w-full">
            <div class="w-full flex flex-row items-center justify-between shadow-card-container-pale">
                <div class="">
                    <h3 class="text-base font-semibold text-primary">Brands Added</h3>
                    <p class="mt-1 text-sm text-secondary">Add as many as you'd like — you can edit any of them later.
                    </p>
                </div>

                <button (click)="brandsStepComplete()" type="button" class="primary-go-button">
                    Continue
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                        class="size-4">
                        <path d="M5 12h14" />
                        <path d="m12 5 7 7-7 7" />
                    </svg>
                </button>
            </div>
        </div>
    </div>
</div>

@if (brandModal()) {
<oba-agency-brand-add (closeModal)="brandModal.set(false)" (brandAdded)="onBrandAdded($event)"></oba-agency-brand-add>
}